import { Activity } from "lucide-react";
import StatusBadge from "./StatusBadge";
import UptimeBar from "./UptimeBar";
import type { StatusComponent } from "@/api/client";

interface ComponentCardProps {
  component: StatusComponent;
  showUptime?: boolean;
}

export default function ComponentCard({
  component,
  showUptime = true,
}: ComponentCardProps) {
  return (
    <div className="border-b border-gray-100 px-4 py-4 last:border-b-0 sm:px-6">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2">
            <h3 className="truncate text-sm font-medium text-gray-900">
              {component.name}
            </h3>
            {component.group && (
              <span className="hidden rounded bg-gray-100 px-1.5 py-0.5 text-xs text-gray-500 sm:inline-block">
                {component.group}
              </span>
            )}
          </div>
          {component.description && (
            <p className="mt-0.5 truncate text-sm text-gray-500">
              {component.description}
            </p>
          )}
        </div>

        <div className="flex items-center gap-3 sm:flex-shrink-0">
          {component.response_ms !== null && (
            <div className="flex items-center gap-1 text-xs text-gray-400">
              <Activity className="h-3 w-3" aria-hidden="true" />
              <span>{component.response_ms}ms</span>
            </div>
          )}
          <StatusBadge status={component.status} />
        </div>
      </div>

      {showUptime && (
        <div className="mt-3">
          <UptimeBar
            uptime7d={component.uptime_7d}
            uptime30d={component.uptime_30d}
            uptime90d={component.uptime_90d}
          />
        </div>
      )}
    </div>
  );
}
